import { __assign } from "tslib";
import { createSmsApi } from '.';
import { createFakePostResponder } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
export var createSmsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createSmsApi('', fakeHttp);
    var smsRelativePath = '/sms';
    var TestKit = {
        whenSendAgentMessage: function (dto) { return createFakePostResponder(fakeHttp, smsRelativePath + "/message")(dto); },
        whenCreateAgentSmsTickets: function (dto) {
            return createFakePostResponder(fakeHttp, smsRelativePath + "/tickets/outbound")(dto);
        },
    };
    return __assign(__assign({}, api), TestKit);
};
//# sourceMappingURL=testkit.js.map